// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import { BookitupNotification } from '../../../../Types/LogT';

const RecommendationAvailabilityChanged: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { personDescription, value } = notification;

  return (
    <Text>
      <Text span weight="bolder">
        {` ${personDescription} `}
      </Text>
      hat den Verfügbarkeitsstatus
      <Text span weight="bolder">
        {` auf ${i18n._(`recommendation.answer.${value}`)} `}
      </Text>
      gesetzt.
    </Text>
  );
};

export default RecommendationAvailabilityChanged;
